import { useTranslation } from "react-i18next";
import { Card, CardHeader, CardContent } from "src/@/components/ui/card";
import { LabelFromAction } from "src/components/@dashboard/automacoes";
import { MultiSelect } from "src/@/components/ui/multi-select";
import { RowInput } from "src/components/forms/RowInput";
import AutomationOnlyExecute from "../components/AutomationOnlyExecute";

const CardTarefaStatusChange = ({
    actionPhase,
    actionState,
    changeActionState,
    users
}) => {
    const { t } = useTranslation(['automation', 'common']);
    return (
        <Card className="w-full">
            <CardHeader>
                <LabelFromAction>
                    {actionPhase.name}
                </LabelFromAction>
            </CardHeader>
            <CardContent>
                <div className="flex flex-col gap-4">
                    <RowInput
                        label={t('actionCards.shared.targetStatusLabel', 'Status alvo')}
                        info={t('actionCards.tarefaStatusChange.targetStatusInfo', 'Filtrar por status de destino da tarefa (os valores dependem do workflow configurado)')}
                        input={
                            <MultiSelect
                                options={[
                                    { value: "A Fazer", label: t('actionCards.tarefaStatusChange.statusAFazer', 'A Fazer') },
                                    { value: "Em Progresso", label: t('actionCards.tarefaStatusChange.statusEmProgresso', 'Em Progresso') },
                                    { value: "Concluído", label: t('status.completed', { ns: 'common', defaultValue: 'Concluído' }) },
                                ]}
                                onValueChange={(e) =>
                                    changeActionState({ name: "tarefaTargetStatus", value: e })
                                }
                                defaultValue={actionState?.tarefaTargetStatus}
                                placeholder={t('actionCards.shared.selectStatusOptionalPlaceholder', 'Selecionar status (opcional)')}
                                variant="inverted"
                                animation={2}
                                maxCount={3}
                            />
                        }
                    />
                    <RowInput
                        label={t('actionCards.tarefaStatusChange.assignedUserLabel', 'Usuário atribuído')}
                        info={t('actionCards.tarefaStatusChange.assignedUserInfo', 'Filtrar por usuário atribuído na tarefa')}
                        input={
                            <MultiSelect
                                options={users}
                                onValueChange={(e) =>
                                    changeActionState({ name: "tarefaUsersAssign", value: e })
                                }
                                defaultValue={actionState?.tarefaUsersAssign}
                                placeholder={t('actionCards.shared.selectUsersOptionalPlaceholder', 'Selecionar usuários (opcional)')}
                                variant="inverted"
                                animation={2}
                                maxCount={3}
                            />
                        }
                    />
                    <AutomationOnlyExecute
                        actionState={actionState}
                        changeActionState={changeActionState}
                    />
                </div>
            </CardContent>
        </Card>
    );
};

export default CardTarefaStatusChange;
